'use client';

import { ANALYTICS_EVENTS, trackEvent } from '@/analytics';
import { Button } from '@wci-tech/core-ui';
import { useTranslations } from 'next-intl';
import { useStyles } from './ExplorePlatformButton.styles';
import { usePathname } from 'next/navigation';
import type { ExplorePlatformButtonProps } from './ExplorePlatformButton.types';
const ExplorePlatformButton = ({
  buttonText,
  href = '/platform',
  location = 'platform_section',
  customStyles,
  variant = 'primary',
}: ExplorePlatformButtonProps) => {
  const styles = useStyles();
  const t = useTranslations('ExplorePlatformButton');
  const pathname = usePathname();

  // Explore Platform button click handler
  const explorePlatformButtonHandler = () => {
    const eventData = {
      page: pathname,
      location: location || 'platform_section',
    };

    trackEvent(ANALYTICS_EVENTS.EXPLORE_PLATFORM_CLICKED, eventData);
  };

  const defaultCustomStyles = {
    base: styles.exploreButton,
  };

  return (
    <Button
      effect="three-d"
      shape="pill"
      href={href}
      customStyles={customStyles ?? defaultCustomStyles}
      variant={variant}
      onClick={explorePlatformButtonHandler}
    >
      {buttonText || t('label')}
    </Button>
  );
};

export default ExplorePlatformButton;
